module.exports = __webpack_public_path__ + "static/media/06.eb915940.jpg";